import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./Detailed.css";

import PvsystActualGTI from "./PvsystActualGTI";
import PvsystActualGHI from "./PvsystActualGHI";
import { NetNormalisedShortFall } from "./NetNormalisedShortFall";
import PvsystContractual from "./PvsystContractual";
import {
  GHIGTIAction,
  netContractualEnergyShortfallAction,
  netNormalisedEnergyShortfallAction,
  pvsystActualTempAction,
  pvsystContractualEnergyAction,
  pvsystGHINormalisedAction,
  pvsystGIINormalisedAction,
} from "../../actions/energyAction";
import GraphLoader from "../../components/GraphLoader";
import PvsystGHINormalised from "./PvsystGHINormalised";
import PvsystGTINormalised from "./PvsystGTINormalised";
import PvsystActualGHIContainer from "./PvsystActualGHIContainer";
import PvsystActualGTIContainer from "./PvsystActualGTIContainer";
import PvsystAmbientTemp from "./PvsystAmbientTemp";
import PvsystGTINormalised2 from "./PvsystGTINormalised2";
import PvsystNetEnergy from "./PvsystNetEnergy";
import { colors3 } from "../../colors/color";
import { useLocation } from "react-router-dom";
const Detailed = ({ selectedLebel, scbsmbDetail, databaseStr }) => {
  const {
    projectDetail,
    loading: loading5,
    error,
  } = useSelector((state) => state.projectDetail);

  const { GHIGTI = [], loading } = useSelector((state) => state.GHIGTI);
  const { pvsystActualTemp = [], loading2 } = useSelector(
    (state) => state.pvsystActualTemp
  );
  const { pvsystContractualEnergy = [], loading3 } = useSelector(
    (state) => state.pvsystContractualEnergy
  );
  const { netNormalisedEnergyShortfall = [], loading4 } = useSelector(
    (state) => state.netNormalisedEnergyShortfall
  );

  const {
    pvsystGHINormalised = [],
    pvsystGIINormalised = [],
    loading3: loading6,
    loading4: loading7,
  } = useSelector((state) => state.pvsystNormalised);

  /* ###   Initialize State to animate progress bar   ### */

  const [progressValueAnimate, setProgressValueAnimate] = useState({
    progress1: false,
    progress2: false,
    progress3: false,
    progress4: false,
    progress5: false,
    progress6: false,
    progress7: false,
    progress8: false,
    progress9: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (selectedLebel?.endTimestamp && databaseStr) {
      // console.log("hre 1");
      dispatch(GHIGTIAction(selectedLebel, databaseStr));
      dispatch(pvsystActualTempAction(selectedLebel, databaseStr));
      dispatch(netContractualEnergyShortfallAction(selectedLebel, databaseStr));

      if (projectDetail?.plantDataAvailability?.netPVsyst) {
        dispatch(pvsystGHINormalisedAction(selectedLebel, databaseStr));
        dispatch(pvsystGIINormalisedAction(selectedLebel, databaseStr));
      }
      dispatch(netNormalisedEnergyShortfallAction(selectedLebel, databaseStr));
      if (projectDetail?.plantDataAvailability?.netContractual) {
        dispatch(pvsystContractualEnergyAction(selectedLebel, databaseStr));
        dispatch(
          netNormalisedEnergyShortfallAction(selectedLebel, databaseStr)
        );
      }
    }
  }, [
    dispatch,
    selectedLebel?.endTimestamp,
    selectedLebel?.startTimestamp,
    databaseStr,
  ]);

  useEffect(() => {
    if (databaseStr) {
      // console.log("hre 2");
      dispatch(GHIGTIAction({ dateRangeType: "month" }, databaseStr));
      dispatch(pvsystActualTempAction({ dateRangeType: "month" }, databaseStr));
      dispatch(
        netContractualEnergyShortfallAction(
          { dateRangeType: "month" },
          databaseStr
        )
      );

      if (projectDetail?.plantDataAvailability?.netPVsyst) {
        dispatch(
          pvsystGHINormalisedAction({ dateRangeType: "month" }, databaseStr)
        );
        dispatch(
          pvsystGIINormalisedAction({ dateRangeType: "month" }, databaseStr)
        );
      }
      dispatch(
        netNormalisedEnergyShortfallAction(
          { dateRangeType: "month" },
          databaseStr
        )
      );

      if (projectDetail?.plantDataAvailability?.netContractual) {
        dispatch(
          pvsystContractualEnergyAction({ dateRangeType: "month" }, databaseStr)
        );

        dispatch(
          netNormalisedEnergyShortfallAction(
            { dateRangeType: "month" },
            databaseStr
          )
        );
      }
    }
  }, [location.pathname, databaseStr,dispatch]);

  return (
    <>
      {loading5 ? (
        <GraphLoader />
      ) : (
        <Grid
          container
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          textAlign={"center"}
        >
          {/* ###   Detailed Container 1 Start   ### */}

          <Grid
            container
            xl={11.8}
            lg={11.8}
            md={11.8}
            sm={11.8}
            xs={11.8}
            style={{
              boxSizing: "border-box",
              borderWidth: "3px",
              // borderRadius: "8px",
              margin: " 0.5vmax  auto 0",
              padding: "0.5vmax",
            }}
            className="detail_overview_container"
            sx={{
              boxShadow: 2,
              display: "grid",
              // Default (xs): 1 column (full width)
              gridTemplateColumns: "1fr",
              // sm: 1 column (full width)
              "@media (min-width: 600px)": {
                gridTemplateColumns: "1fr",
              },
              // md: 1 column (full width)
              "@media (min-width: 900px)": {
                gridTemplateColumns: "1fr",
              },
              // lg: 2 columns (50% each with gap)
              "@media (min-width: 1200px)": {
                gridTemplateColumns: "1fr 1fr 1fr",
              },
              gap: "0.5vmax", // Gap only applies in lg view
            }}
          >
            <PvsystActualGHIContainer
              progressValueAnimate={progressValueAnimate}
              setProgressValueAnimate={setProgressValueAnimate}
              GHIGTI={GHIGTI}
              loading={loading}
            />

            <PvsystActualGTIContainer
              progressValueAnimate={progressValueAnimate}
              setProgressValueAnimate={setProgressValueAnimate}
              GHIGTI={GHIGTI}
              loading={loading}
            />
            <PvsystAmbientTemp
              progressValueAnimate={progressValueAnimate}
              setProgressValueAnimate={setProgressValueAnimate}
              pvsystActualTemp={pvsystActualTemp}
              loading={loading2}
            />
          </Grid>

          {/* ###   Detailed Container 1 end ### */}

          {/* ###   Detailed Container 2 start ### */}

          <Grid
            sx={{ boxShadow: 2 }}
            item
            xl={11.8}
            lg={11.8}
            md={11.8}
            sm={11.8}
            xs={11.8}
            style={{
              background:
                "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
              boxSizing: "border-box",
              borderWidth: "3px",
              // borderRadius: "8px",
              margin: "0.5vmax auto 0",
              padding: "0.5vmax",
            }}
          >
            <Grid
              container
              sx={{
                display: "grid",
                // Default (xs): 1 column (full width)
                gridTemplateColumns: "1fr",
                // sm: 1 column (full width)
                "@media (min-width: 600px)": {
                  gridTemplateColumns: "1fr",
                },
                // md: 1 column (full width)
                "@media (min-width: 900px)": {
                  gridTemplateColumns: "1fr",
                },
                // lg: 2 columns (50% each with gap)
                "@media (min-width: 1200px)": {
                  gridTemplateColumns: "1fr 1fr",
                },
                gap: "0.5vmax", // Gap only applies in lg view
              }}
            >
              <Grid
                // item
                // lg={6}
                // md={12}
                // sm={12}
                // xs={12}
                sx={{
                  position: "relative",
                  backgroundColor: "#fff",
                  padding: "1vmax",
                  overflow: "auto",
                  minHeight: "40vh",
                }}
              >
                <PvsystActualGHI GHIGTI={GHIGTI} loading={loading} />
              </Grid>
              <Grid
                // item
                // lg={6}
                // md={12}
                // sm={12}
                // xs={12}
                sx={{
                  position: "relative",
                  backgroundColor: "#fff",
                  padding: "1vmax",
                  overflow: "auto",
                }}
              >
                <PvsystActualGTI
                  barColors={[colors3[0], colors3[1]]}
                  GHIGTI={GHIGTI}
                  loading={loading}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* ###   Detailed Container 2 end ### */}

          {/* ###   Detailed Container 3 start ### */}
          <Grid
            sx={{ boxShadow: 2 }}
            item
            xl={11.8}
            lg={11.8}
            md={11.8}
            sm={11.8}
            xs={11.8}
            style={{
              background:
                "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
              boxSizing: "border-box",
              borderWidth: "3px",
              // borderRadius: "8px",
              margin: "0.5vmax auto",
              padding: "0.5vmax",
            }}
          >
            <Grid
              container
              sx={{
                display: "grid",
                // Default (xs): 1 column (full width)
                gridTemplateColumns: "1fr",
                // sm: 1 column (full width)
                "@media (min-width: 600px)": {
                  gridTemplateColumns: "1fr",
                },
                // md: 1 column (full width)
                "@media (min-width: 900px)": {
                  gridTemplateColumns: "1fr",
                },
                // lg: 2 columns (50% each with gap)
                "@media (min-width: 1200px)": {
                  gridTemplateColumns: "1fr 1fr",
                },
                gap: "0.5vmax", // Gap only applies in lg view
              }}
            >
              <Grid
                sx={{
                  position: "relative",
                  backgroundColor: "#fff",
                  padding: "0.5vmax",
                  overflow: "auto",
                }}
              >
                {projectDetail &&
                projectDetail["plantDataAvailability"]["netPVsyst"] ? (
                  <PvsystGHINormalised
                    pvsystNormalised={pvsystGHINormalised}
                    loading={loading6}
                  />
                ) : (
                  <NetNormalisedShortFall
                    netNormalisedEnergyShortfall={netNormalisedEnergyShortfall}
                    loading={loading4}
                  />
                )}
              </Grid>
              <Grid
                sx={{
                  position: "relative",
                  backgroundColor: "#fff",
                  padding: "0.5vmax",
                  overflow: "auto",
                }}
              >
                {projectDetail &&
                projectDetail["plantDataAvailability"]["netPVsyst"] ? (
                  <PvsystGTINormalised
                    pvsystNormalised={pvsystGIINormalised}
                    loading={loading7}
                  />
                ) : (
                  <PvsystContractual
                    pvsystContractualEnergy={pvsystContractualEnergy}
                    loading={loading3}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid></Grid>
          <Grid sx={{ border: "2px solid red" }} container>
            <Grid
              sx={{ border: "2px solid red" }}
              item
              lg={6}
              md={12}
              sm={12}
              xs={12}
            >
              Lorem, ipsum.
            </Grid>
            <Grid
              sx={{ border: "2px solid red" }}
              item
              lg={6}
              md={12}
              sm={12}
              xs={12}
            >
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid
              voluptate ab expedita cupiditate voluptas voluptatem veniam
              cumque, vitae sapiente quasi quis, ratione autem aspernatur
              explicabo? Accusantium, nisi perspiciatis. Obcaecati qui eveniet
              ipsa deleniti quos accusamus, neque debitis enim unde consectetur
              ducimus magni ipsam, explicabo nam minima facere exercitationem
              nihil beatae blanditiis repellat quae! Soluta harum, earum est
              incidunt eveniet inventore ad distinctio nesciunt odit nobis?
              Ullam perspiciatis consequatur eos ex pariatur exercitationem
              debitis a maxime rerum quaerat corrupti odio deleniti obcaecati
              dolore dolor, maiores laborum sequi! Amet ipsa, veniam commodi non
              atque eos? Repudiandae tempora quod deserunt recusandae omnis
              mollitia!
            </Grid>
          </Grid> */}

          {/* ###   Detailed Container 3 end ### */}

          {/* ###   Detailed Container 4 start ### */}
          {projectDetail &&
            !projectDetail?.["plantDataAvailability"]?.["netPVsyst"] && (
              <Grid
                sx={{ boxShadow: 2 }}
                item
                xl={11.8}
                lg={11.8}
                md={11.8}
                sm={11.8}
                xs={11.8}
                style={{
                  background:
                    "linear-gradient(to bottom, rgb(3, 99, 125),rgb(4, 128, 162),rgb(4, 135, 172))",
                  boxSizing: "border-box",
                  borderWidth: "3px",
                  // borderRadius: "8px",
                  margin: "0 auto 0.5vmax",
                  padding: "0.5vmax",
                }}
              >
                <Grid
                  container
                  sx={{
                    display: "grid",
                    // Default (xs): 1 column (full width)
                    gridTemplateColumns: "1fr",
                    // sm: 1 column (full width)
                    "@media (min-width: 600px)": {
                      gridTemplateColumns: "1fr",
                    },
                    // md: 1 column (full width)
                    "@media (min-width: 900px)": {
                      gridTemplateColumns: "1fr",
                    },
                    // lg: 2 columns (50% each with gap)
                    "@media (min-width: 1200px)": {
                      gridTemplateColumns: "1fr 1fr",
                    },
                    gap: "0.5vmax", // Gap only applies in lg view
                  }}
                >
                  <Grid
                    sx={{
                      position: "relative",
                      backgroundColor: "#fff",
                      padding: "0.5vmax",
                      overflow: "auto",
                    }}
                  >
                    <PvsystGTINormalised2
                      pvsystNormalised={pvsystContractualEnergy}
                      loading={loading3}
                    />
                  </Grid>
                  <Grid
                    sx={{
                      position: "relative",
                      backgroundColor: "#fff",
                      padding: "0.5vmax",
                      overflow: "auto",
                    }}
                  >
                    <PvsystNetEnergy
                      pvsystContractualEnergy={pvsystContractualEnergy}
                      loading={loading3}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
        </Grid>
      )}
    </>
  );
};

export default Detailed;
